import moment from 'moment';
import AppService from '../app.service';
import JSZip from 'jszip';

export function getCurrentQuarter() {
  const now = new Date();
  const month = now.getMonth() + 1;
  const year = now.getFullYear();
  let date = '';
  if (month < 3) {
    date = '10-01';
  } else if (month < 6) {
    date = '01-01';
  } else if (month < 9) {
    date = '04-01';
  } else if (month < 12) {
    date = '07-01';
  } else {
    date = '10-01';
  }
  return date;
}

export function getCurrentFreshnessKpiYear() {
  const month = new Date().getMonth() + 1;
  if (month < 3) {
    return new Date().getFullYear() - 1;
  }
  return new Date().getFullYear();
}

export function downloadAllZip(files, fileName) {
  return new Promise(async (resolve, reject) => {
    const zip = new JSZip();
    const appService = new AppService();

    try {
      const filePromises = files.map(async file => {
        const src = await appService.getStreamDocuments(file);
        if (src) {
          console.log(src);
          let content = src;
          if (src.startsWith('blob:')) {
            const response = await fetch(src);
            content = await response.blob();
          }
          zip.file(file, content);
        }
      });

      await Promise.all(filePromises);
      console.log(zip.files);
      const zipBlob = await zip.generateAsync({ type: 'blob' });

      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(zipBlob);
      downloadLink.download = fileName + '.zip';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      if (downloadLink.parentNode) {
        document.body.removeChild(downloadLink);
      }
      URL.revokeObjectURL(downloadLink.href);
      resolve(true);
    } catch (error) {
      console.error('Error downloading files:', error);
      resolve(true);
    }
  });
}

export function downloadFile(url, fileName, isStatic = false) {
  return new Promise(async (resolve, reject) => {
    const appService = new AppService();
    try {
      const src = await appService.getFile(url, isStatic);
      let a = document.createElement('a');
      a.setAttribute('target', '_blank');
      a.href = src;
      a.download = fileName ?? url;
      document.body.appendChild(a);
      a.click();
      if (a.parentNode) {
        document.body.removeChild(a);
      }
      if (src) {
        resolve(true);
      }
    } catch {
      resolve(true);
    }
  });
}

export function getSecureRandomNumber(min, max) {
  const crypto = window.crypto || window.msCrypto;
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);
  const randomNumber = array[0] / (Math.pow(2, 32) - 1);
  return Math.floor(randomNumber * (max - min + 1)) + min;
}

export function handleSampleName(sample, t) {
  const yearDatProd = sample.dat_production?.substring(0, 4);
  const monthDatProd = t(`month_${sample.dat_production?.substring(5, 7) - 1}`);
  const dayDatProd = sample.dat_production?.substring(8, 10);

  const yearDatExp = sample.dat_expire?.substring(0, 4);
  const monthDatExp = t(`month_${sample.dat_expire?.substring(5, 7) - 1}`);
  const datDatExp = sample.dat_expire?.substring(8, 10);

  return `${sample?.str_site_name ?? ''} - Pr. ${
    sample.dat_production
      ? dayDatProd + '/' + monthDatProd + '/' + yearDatProd
      : 'N/A'
  } - Ex. ${
    sample.dat_expire ? datDatExp + '/' + monthDatExp + '/' + yearDatExp : 'N/A'
  } - ${sample.str_batch ? sample.str_batch : 'N/A'}`;
}

export function getFile(url) {
  const appService = new AppService();
  return appService.getFile(url);
}

export function getNextMonth(date, nextMonth = 1) {
  const nowDate = moment(date);
  return new Date(nowDate.year(), nowDate.month() + nextMonth, 1);
}

export function generateReport(Api, data, t) {
  return new Promise(resolve => {
    Api(data).then(
      res => {
        if (
          res.status === 'success' &&
          res.file &&
          res.file === 'report.xlsx'
        ) {
          window.alert(t('common_report_not_have_data'));
        } else if (
          res.status === 'success' &&
          res.file &&
          res.file !== 'report.xlsx'
        ) {
          downloadFile(res.file);
        } else {
          window.alert(res.message);
        }
        resolve();
      },
      error => {
        window.alert(t('you_do_not_have_privilege_to_export_this_report'));
        resolve();
      },
    );
  });
}
export function generateReportByTicket(Api, data, t, callbacks = {}) {
  return new Promise(resolve => {
    Api(data).then(
      res => {
        if (
          res.status === 'success' &&
          res.file &&
          res.file === 'report.xlsx'
        ) {
          if (!callbacks.onError) {
            window.alert(t('common_report_not_have_data'));
          }
          callbacks.onError?.(t('common_report_not_have_data'));
          resolve();
        } else if (
          res.status === 'success' &&
          res.file &&
          res.file !== 'report.xlsx'
        ) {
          createDownloadTicket({ fileName: res.file }).then(() => {
            callbacks.onSuccess?.();
            resolve();
          }).catch(() => {
            callbacks.onError?.(t('download_report_failed'));
            resolve();
          });
        } else {
          if (!callbacks.onError) {
            window.alert(res.message);
          }
          callbacks.onError?.(res.message);
          resolve();
        }
      },
      error => {
        if (!callbacks.onError) {
          window.alert(t('you_do_not_have_privilege_to_export_this_report'));
        }
        callbacks.onError?.(t('you_do_not_have_privilege_to_export_this_report'));
        resolve();
      },
    );
  });
}

export function getOpts() {
  return [
    {
      value: '-1',
      label: 'All',
    },
    {
      value: 'true',
      label: 'Yes',
    },
    {
      value: 'false',
      label: 'No',
    },
  ];
}

export function getHeaders(filterHeaders, editPermission) {
  return filterHeaders.filter((item, index) => {
    return (
      editPermission[index].bol_status === null ||
      editPermission[index].bol_status === 1
    );
  });
}

export function getAllStorage(tag = 'local') {
  const allStorage = {};
  const arrStorage = tag === 'local' ? localStorage : sessionStorage;
  for (let i = 0; i < arrStorage.length; i++) {
    const key = arrStorage.key(i);
    allStorage[key] = arrStorage.getItem(key);
  }
  return allStorage;
}

export function setCookie(name, value, time) {
  // const expires = new Date()
  // expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)
  document.cookie = `${name}=${value};expires=${time};path=/`;
}

export function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
const pendingRequests = new Map();
export function SentServiceBySignal(serviceMethod, requestId, ...args) {
  return new Promise((resolve, reject) => {
    if (pendingRequests.has(requestId)) {
      console.log('Cancelling previous request:', requestId);
      pendingRequests.get(requestId)?.abort();
    }
    const controller = new AbortController();
    pendingRequests.set(requestId, controller);

    serviceMethod(...args, { signal: controller.signal })
      .then(res => {
        if (!controller.signal.aborted) {
          resolve(res);
        }
      })
      .catch(error => {
        if (error.name === 'AbortError') {
          console.log('Request was cancelled:', requestId);
          resolve(null);
        } else {
          reject(error);
        }
      })
      .finally(() => {
        if (pendingRequests.get(requestId) === controller) {
          pendingRequests.delete(requestId);
        }
      });
  });
}

export function createDownloadTicket(data = { fileName: 'report.xlsx' }) {
  const appService = new AppService();
  return new Promise(async (resolve, reject) => {
    appService.createDownloadTicket(data).then(
      res => {
        let a = document.createElement('a');
        a.setAttribute('target', '_blank');
        a.href = res.downloadUrl;
        a.download = data.fileName;
        document.body.appendChild(a);
        a.click();
        if (a.parentNode) {
          document.body.removeChild(a);
        }
        resolve(true);
      },
      error => reject(error),
    );
  });
}

export function getFromStorage(
  key,
  storageType = 'local',
  defaultValue = null,
) {
  try {
    const storage = storageType === 'local' ? localStorage : sessionStorage;
    const stored = storage.getItem(key);
    if (!stored) return defaultValue;
    const parsed = JSON.parse(stored);
    return parsed !== null && parsed !== undefined ? parsed : defaultValue;
  } catch (error) {
    console.error(`Failed to parse ${key} from ${storageType}Storage:`, error);
    const storage = storageType === 'local' ? localStorage : sessionStorage;
    storage.removeItem(key);
    return defaultValue;
  }
}

export function getFromLocalStorage(key, defaultValue = null) {
  return getFromStorage(key, 'local', defaultValue);
}

export function getFromSessionStorage(key, defaultValue = null) {
  return getFromStorage(key, 'session', defaultValue);
}

export function FormatOption(options, label = 'label', value = 'value') {
  return options.map(item => ({
    label: item[label],
    value: item[value],
  }));
}

export function changeLanguage(i18n, language) {
  i18n.changeLanguage(language);
  localStorage.setItem('system_language', language ?? 'en');
}
export async function copyToClipboard(text) {
  if (!text) {
    return false;
  }

  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    const success = document.execCommand('copy');
    document.body.removeChild(textarea);

    return success;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
}
